import is from 'helpers/is';
import { noop } from 'lodash-es';

const Icon = ({ icon, className, onClick = noop }) => {
  let SVG;

  try {
    SVG = require(`../../public/icons/${icon}.inline.svg`).default;
  } catch (e) {
    if (is().dev) {
      console.warn(`icon ${icon} not found`);
    }
  }

  return (
    <i className={['icon', className || ''].join(' ')} onClick={onClick}>
      {SVG && <SVG />}
    </i>
  );
};

export default Icon;
